import { createRouter, createWebHistory } from 'vue-router'
// Store import removed - no authentication required

// Import components
import Dashboard from '@/views/Dashboard.vue'
import Transactions from '@/views/Transactions.vue'
import TransactionForm from '@/views/TransactionForm.vue'
import DailyReports from '@/views/reports/DailyReports.vue'
import MonthlyReports from '@/views/reports/MonthlyReports.vue'
import WeeklyReports from '@/views/reports/WeeklyReports.vue'
import Analytics from '@/views/Analytics.vue'

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },


  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {} // No authentication required
  },
  {
    path: '/transactions',
    name: 'Transactions',
    component: Transactions,
    meta: {} // No authentication required
  },
  {
    path: '/transactions/new',
    name: 'NewTransaction',
    component: TransactionForm,
    meta: {} // No authentication required
  },
  {
    path: '/transactions/:id/edit',
    name: 'EditTransaction',
    component: TransactionForm,
    props: true,
    meta: {} // No authentication required
  },
  {
    path: '/reports/daily',
    name: 'DailyReports',
    component: DailyReports,
    meta: {} // No authentication required
  },
  {
    path: '/reports/monthly',
    name: 'MonthlyReports',
    component: MonthlyReports,
    meta: {} // No authentication required
  },
  {
    path: '/reports/weekly',
    name: 'WeeklyReports',
    component: WeeklyReports,
    meta: {} // No authentication required
  },
  {
    path: '/analytics',
    name: 'Analytics',
    component: Analytics,
    meta: {} // No authentication required
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Simplified navigation guard - no authentication required
router.beforeEach((to, from, next) => {
  console.log(`🔄 Navigation guard triggered: ${from.path} → ${to.path}`)
  console.log(`📍 Route details:`, {
    from: { name: from.name, path: from.path, meta: from.meta },
    to: { name: to.name, path: to.path, meta: to.meta }
  })
  
  // All routes are accessible without authentication
  console.log('✅ Navigation allowed - no authentication required')
  next()
})

// Navigation completed logging
router.afterEach((to, from) => {
  console.log(`✅ Navigation completed: ${from.path} → ${to.path}`)
})

export default router 